// extracted by mini-css-extract-plugin
export var errorsContainer = "_tf-1";
export var link = "_tf-0";